<sepidz-review class="review">
  <div review-filters>
    <div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('FilterInfo')">
          <span>{{ "ClientApp.BackOffice.SELL.SellCustomerReview.FilterInfo" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'FilterInfo'"></i>
        </div>
        <div *ngIf="selected === 'FilterInfo'">
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="number"
              [form]="formGroup"
              [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.StartNumber' | translate"
              name="StartNumber"
              key="StartNumber"
              [items]="[{ Name: translate('ClientApp.BackOffice.SELL.SellCustomerReview.StartNumber') }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="number"
              [form]="formGroup"
              [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.EndNumber' | translate"
              name="EndNumber"
              key="EndNumber"
              [items]="[{ Name: translate('ClientApp.BackOffice.SELL.SellCustomerReview.EndNumber') }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              [form]="formGroup"
              valueType="boolean"
              [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.IsGoods' | translate"
              name="IsGoods"
              key="IsGoods"
              [items]="[{ Name: translate('ClientApp.BackOffice.SELL.SellCustomerReview.IsGoods'), Value: false }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              [form]="formGroup"
              valueType="boolean"
              [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.IsService' | translate"
              name="IsService"
              key="IsService"
              [items]="[{ Name: translate('ClientApp.BackOffice.SELL.SellCustomerReview.IsService'), Value: false }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 5px">
            <sepidz-static-select-review
              valueType="number"
              [form]="formGroup"
              [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.SlaveNo' | translate"
              name="SlaveNo"
              key="SlaveNo"
              [items]="[{ Name: translate('ClientApp.BackOffice.SELL.SellCustomerReview.SlaveNo') }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="text"
              [form]="formGroup"
              [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.TraceElement' | translate"
              name="TraceElement"
              key="TraceElement"
              [items]="[{ Name: translate('ClientApp.BackOffice.SELL.SellCustomerReview.TraceElement'), Value: '' }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="date"
              [form]="formGroup"
              [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.ReceiptDate' | translate"
              name="ReceiptDate"
              key="ReceiptDate"
              [items]="[{ Name: translate('ClientApp.BackOffice.SELL.SellCustomerReview.ReceiptDate'), Value: '' }]">
            </sepidz-static-select-review>
          </section>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('StatusKindTitle')">
          <span>{{ "ClientApp.BackOffice.SELL.StatusKind.StatusKindTitle" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'StatusKindTitle'"></i>
        </div>
        <div *ngIf="selected === 'StatusKindTitle'">
          <sepidz-remote-select-review
            [title]="'ClientApp.BackOffice.SELL.StatusKind.StatusKindTitle' | translate"
            [form]="formGroup"
            name="StatusKind"
            key="StatusKindIds"
            apiName="Lookup"
            systemName="SELL"
            category="StatusKind">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Branch')">
          <span>{{ "ClientApp.BackOffice.SELL.SellCustomerReview.Branch" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'Branch'"></i>
        </div>
        <div *ngIf="selected === 'Branch'">
          <sepidz-remote-select-review
            [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.Branch' | translate"
            [form]="formGroup"
            name="Branch"
            key="BranchIds"
            apiName="Branch/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
    </div>
  </div>
  <div review-content>
    <ssg-tabset class="tabset" (tabChange)="selectTab($event)">
      <ssg-tab
        *hasPermission="['SellCustomer:SellCustomerReview/GetSellVoucherKind', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.SELL.SellCustomerReview.SellVoucherKind' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.SELL.SellCustomerReview.SellVoucherKind' | translate)"
          name="VoucherKindId"
          [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.SellVoucherKind' | translate"
          apiName="SellCustomerReview/GetSellVoucherKind"
          areaName="SellCustomer"
          [groupable]="false"
          [columns]="GetSellVoucherKindColumns"
          [filtering]="true"
          pathPreFix="SELL"
          displayNameColumn="VoucherKindTitle"
          key="SellVoucherKindIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['SellCustomer:SellCustomerReview/GetSellKind', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.SELL.SellCustomerReview.SellKind' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.SELL.SellCustomerReview.SellKind' | translate)"
          name="SellKindId"
          [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.SellKind' | translate"
          apiName="SellCustomerReview/GetSellKind"
          areaName="SellCustomer"
          [groupable]="false"
          [columns]="GetSellKindColumns"
          [filtering]="true"
          pathPreFix="SELL"
          displayNameColumn="SellKindTitle"
          key="SellKindIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['SellCustomer:SellCustomerReview/GetCustomer', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.SELL.SellCustomerReview.Customer' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.SELL.SellCustomerReview.Customer' | translate)"
          name="CustomerId"
          [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.Customer' | translate"
          apiName="SellCustomerReview/GetCustomer"
          areaName="SellCustomer"
          [columns]="GetCustomerColumns"
          [filtering]="true"
          pathPreFix="SELL"
          displayNameColumn="DetailLedgerCode"
          key="CustomerIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['SellCustomer:SellCustomerReview/GetWarehouse', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.SELL.SellCustomerReview.Warehouse' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.SELL.SellCustomerReview.Warehouse' | translate)"
          name="WarehouseiD"
          [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.Warehouse' | translate"
          apiName="SellCustomerReview/GetWarehouse"
          areaName="SellCustomer"
          [columns]="GetWarehouseColumns"
          [filtering]="true"
          pathPreFix="SELL"
          displayNameColumn="WarehouseTitle"
          key="WarehouseIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['SellCustomer:SellCustomerReview/GetGoodsGroup', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.SELL.SellCustomerReview.GoodsGroup' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.SELL.SellCustomerReview.GoodsGroup' | translate)"
          name="GoodsGroupId"
          [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.GoodsGroup' | translate"
          apiName="SellCustomerReview/GetGoodsGroup"
          areaName="SellCustomer"
          [columns]="GetGoodsGroupColumns"
          [filtering]="true"
          [groupable]="false"
          pathPreFix="SELL"
          displayNameColumn="GoodsGroupTitle"
          key="GoodsGroupIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['SellCustomer:SellCustomerReview/GetGoods', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.SELL.SellCustomerReview.Goods' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.SELL.SellCustomerReview.Goods' | translate)"
          name="GoodsId"
          [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.Goods' | translate"
          apiName="SellCustomerReview/GetGoods"
          areaName="SellCustomer"
          [columns]="GetGoodsColumns"
          [filtering]="true"
          [groupable]="true"
          pathPreFix="SELL"
          displayNameColumn="GoodsTitle"
          key="GoodsIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['SellCustomer:SellCustomerReview/GetSeller', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.SELL.SellCustomerReview.Seller' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.SELL.SellCustomerReview.Seller' | translate)"
          name="GoodsId"
          [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.Seller' | translate"
          apiName="SellCustomerReview/GetSeller"
          areaName="SellCustomer"
          [columns]="GetSellerColumns"
          [filtering]="true"
          [groupable]="true"
          pathPreFix="SELL"
          displayNameColumn="SellerTitle"
          key="SellerIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['SellCustomer:SellCustomerReview/GetVoucherHeader', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.SELL.SellCustomerReview.VoucherHeader' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.SELL.SellCustomerReview.VoucherHeader' | translate)"
          name="SELLVoucherHeaderId"
          [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.VoucherHeader' | translate"
          apiName="SellCustomerReview/GetVoucherHeader"
          areaName="SellCustomer"
          [columns]="GetVoucherHeaderColumns"
          [filtering]="false"
          [groupable]="true"
          pathPreFix="SELL"
          displayNameColumn="VoucherNo"
          key="VoucherHeaderIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['SellCustomer:SellCustomerReview/GetVoucherDetail', 'Same']"
        [tabTitle]="'ClientApp.BackOffice.SELL.SellCustomerReview.VoucherDetail' | translate">
        <sepidz-grid-review
          *ngIf="
            isActveTab('ClientApp.BackOffice.SELL.SellCustomerReview.VoucherDetail' | translate) &&
            GetVoucherDetailColumns &&
            GetVoucherDetailColumns.length > 0
          "
          name="VoucherDetail"
          [title]="'ClientApp.BackOffice.SELL.SellCustomerReview.VoucherDetail' | translate"
          apiName="SellCustomerReview/GetVoucherDetail"
          areaName="SellCustomer"
          [columns]="GetVoucherDetailColumns"
          [selective]="false"
          [filtering]="true"
          [isModal]="false"
          pathPreFix="SELL"
          [actionTregger]="onActionClick"
          [actions]="actions"
          key="VoucherDetailIds">
        </sepidz-grid-review>
      </ssg-tab>
    </ssg-tabset>
  </div>
</sepidz-review>
